export enum ELetterInLeuiTypes {
  TMO = 'TMO',
  HOUSING = 'Housing',
  EMPLOYER = 'Employer'
}
